import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { ResponsiveImage, Link } from "@quintype/components";
import { getHeroImage, getStoryMetadata } from "../../../utils";
import "./card-image.m.css";

export const CardImageBase = ({ story = {}, config = {} }) => {
  const heroS3Key = getHeroImage(story, config);
  const slug =
    story["story-template"] === "news-elsewhere" ? get(story, ["metadata", "reference-url"], story.slug) : story.slug;
  return story["story-template"] === "news-elsewhere" ? (
    <a
      href={slug}
      styleName="hero-image"
      className="hero-image"
      target={story["story-template"] === "news-elsewhere" ? "_blank" : ""}
    >
      <figure className="figure-wrapper">
        <ResponsiveImage
          slug={heroS3Key}
          metadata={getStoryMetadata(story)}
          aspectRatio={[16, 9]}
          defaultWidth={480}
          widths={[250, 480, 640]}
          sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
          imgParams={{ auto: ["format", "compress"] }}
          className="responsive-img"
        />
      </figure>
    </a>
  ) : (
    <Link
      href={"/" + slug}
      styleName="hero-image"
      className="hero-image"
      target={story["story-template"] === "news-elsewhere" ? "_blank" : ""}
    >
      <figure className="figure-wrapper">
        <ResponsiveImage
          slug={heroS3Key}
          metadata={getStoryMetadata(story)}
          aspectRatio={[16, 9]}
          defaultWidth={480}
          widths={[250, 480, 640]}
          sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
          imgParams={{ auto: ["format", "compress"] }}
          className="responsive-img"
        />
      </figure>
    </Link>
  );
};

CardImageBase.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object
};

function mapStateToProps(state) {
  return {
    config: get(state, ["qt", "config"], {})
  };
}

export const CardImage = connect(mapStateToProps)(CardImageBase);
